<a class="font-body3 nav-link" (click)="scrollTo()" *ngIf="!navLink.disable">{{navLink.name}}</a>
